export default {
  senderIds(state) {
    return state.senderIds;
  },
};
